import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "company-data" }
const _hoisted_2 = {
  key: 0,
  class: "type"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", {compact: $props.compact}])
  }, [
    ($props.compact)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: "hash-02-a",
          class: "hash",
          size: $props.size,
          stroke: "var(--brand-700)"
        }, null, 8 /* PROPS */, ["size"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "topic-icon",
          style: _normalizeStyle({width: $props.size, height: $props.size})
        }, [
          _createVNode(_component_Icon, {
            icon: "hash-02-a",
            size: `calc(${$props.size} * 0.5)`,
            stroke: "var(--brand-700)",
            "stroke-width": "1"
          }, null, 8 /* PROPS */, ["size"])
        ], 4 /* STYLE */)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Ellipsis, {
        class: "title",
        text: $props.name
      }, null, 8 /* PROPS */, ["text"]),
      (!$props.compact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Icon, {
              icon: "hash-02-a",
              size: "1.2rem",
              stroke: "var(--text-tertiary-600)"
            }),
            _cache[0] || (_cache[0] = _createTextVNode(" Topic "))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}